import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { getLocalDatabaseVersion } from 'src/app/utils';

enum LocalStorageKey {
  PWA_LOCAL_DATABASE_VERSION = 'pwa-local-database-version'
}

@Injectable({
  providedIn: 'root'
})
export class LocalDatabaseVersionService {
  private _currentDatabaseVersion = new BehaviorSubject<number>(0);

  public readonly getCurrentLocalDatabaseVersion = this._currentDatabaseVersion.asObservable();

  constructor() {
    const localDatabaseVersion = getLocalDatabaseVersion();
    this._currentDatabaseVersion.next(localDatabaseVersion);
  }

  setLocalDatabaseVersion(version: number): void {
    localStorage.setItem(LocalStorageKey.PWA_LOCAL_DATABASE_VERSION, String(version));
    this._currentDatabaseVersion.next(version);
  }

  getLocalDatabaseVersion(): number {
    const localDatabaseVersion = localStorage.getItem(LocalStorageKey.PWA_LOCAL_DATABASE_VERSION);

    if (localDatabaseVersion) return parseFloat(localDatabaseVersion);
    else {
      localStorage.setItem(LocalStorageKey.PWA_LOCAL_DATABASE_VERSION, String(0.0));
      return 0.0;
    }
  }
}
